import { useMemo } from "react"

import { useBounceGlobalValues, useTranslation } from "@bounce/i18n"

import type { CityData } from "../../../../libs/bounce/cities"
import type { FormattedEvent } from "../../../../libs/prismic/event/types"
import { getCityCurrency } from "../../../../utils/city"
import type { BaseEventInterpolations } from "../utils/getEventInterpolations"
import { getBaseEventInterpolations } from "../utils/getEventInterpolations"

export type Interpolations = BaseEventInterpolations

export const useInterpolations = ({ event, city }: { event: FormattedEvent; city: CityData }): Interpolations => {
  const { i18n } = useTranslation()
  const currency = getCityCurrency(city)
  const bounceGlobals = useBounceGlobalValues({ currency })

  const interpolations = useMemo(
    () =>
      getBaseEventInterpolations({
        event,
        city,
        language: i18n.language,
        bounceGlobals,
        currency,
      }),
    [bounceGlobals, city, currency, event, i18n.language],
  )

  return interpolations
}
